import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'ngxShowEnabled'})
export class ShowEnabledPipe implements PipeTransform {
    transform(arr: any[]): any[] {
        return arr?.filter((item) => item.enabled);
    }
}
